/*
 * @Author: lihang
 * @Date: 2020-08-05 16:07:18
 * @LastEditTime: 2020-08-05 16:07:23
 * @LastEditors: lihang
 * @Description:
 * @FilePath: \winupon-and-vue\components\_util\eventScrollbar.js
 */
let supportsPassive = false;
if (process.browser) {
  try {
    let opts = Object.defineProperty({}, 'passive', {
      get: function() {
        return (supportsPassive = true);
      },
    });
    typeof window !== 'undefined' && window.addEventListener('test', null, opts);
  } catch (e) {
    e;
  }
}
/**
 *
 * @param {Object} el 事件对象
 * @param {String} event 事件
 * @param {function} fn 回调方法
 * @param {Boolean} passive 是否进行检测
 */
export const addEvent = (el, event, fn, passive = true) => {
  if (el) {
    if (el.addEventListener) {
      el.addEventListener(
        event,
        fn,
        supportsPassive
          ? {
              passive: passive,
            }
          : false,
      );
    } else {
      el.attachEvent('on' + event, fn);
    }
  } else {
    setTimeout(() => {
      addEvent(el, event, fn, passive);
    }, 500);
  }
};

export const removeEvent = (el, event, fn) => {
  if (el) {
    el.removeEventListener(event, fn);
  } else {
    setTimeout(() => {
      el && el.removeEventListener(event, fn);
    }, 500);
  }
};
